import { useContext } from 'react';
import type { FormErrorData, SocialShareData, LoginMetricsProps, LoginErrorProps } from '../lib';
import { MetricsContext } from '../lib';

type MetricsEventData =
  | FormErrorData
  | SocialShareData
  | LoginMetricsProps
  | LoginErrorProps; /* add the other event metrics props using | symbol */

export const MetricsEvent = {
  SIGN_IN_ONLY: 'sign-in-only',
  SIGN_OUT_ONLY: 'sign-out-only',
  LOG_IN: 'log-in',
  LOG_IN_ERROR: 'log-in-error',
  FORM_ERROR: 'form-error',
  SOCIAL_SHARE_CLICK: 'social-share-click',
} as const;

export type MetricsEventType = (typeof MetricsEvent)[keyof typeof MetricsEvent];

export function useEventMetrics() {
  const { metrics } = useContext(MetricsContext);
  const setEventMetrics = (eventType: MetricsEventType, eventData?: MetricsEventData) => {
    switch (eventType) {
      case MetricsEvent.SIGN_OUT_ONLY: {
        metrics.setSignoutEvent();
        break;
      }
      case MetricsEvent.SIGN_IN_ONLY: {
        metrics.setLoginEvent();
        break;
      }
      case MetricsEvent.LOG_IN_ERROR: {
        metrics.setLoginError([eventData as LoginErrorProps]);
        break;
      }
      case MetricsEvent.LOG_IN: {
        metrics.setLoginUserData([eventData as LoginMetricsProps]);
        break;
      }
      case MetricsEvent.SOCIAL_SHARE_CLICK:
        metrics.setSocialShareData([eventData as SocialShareData]);
        break;
      case MetricsEvent.FORM_ERROR:
        metrics.setFormErrorData([eventData as FormErrorData]);
        break;
      /* add case for othe pages */
    }
  };

  return { setEventMetrics };
}
